<template>
  <div>
    <v-btn outlined small @click="accion" :color="color">
      {{ texto }}
      <v-icon right>{{icono === "import" ? "mdi-upload" : "mdi-file-excel"}}</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    texto: String,
    color: String,
    icono: String,
  },
  methods: {
    accion() {
      this.$emit("accion");
    },
  },
};
</script>